/* eslint-disable import/extensions */
import { call, put, takeLatest } from 'redux-saga/effects';
import _ from 'lodash';
import { del } from 'utils/LocalStorageUtil';
import { LOAD_USER_MODIFY } from '../constants';
import {
  pendingUserModify,
  errorUserModify,
  successUserModify,
} from '../actions';
import { getUserModify } from '../service';

export function* sendUserModify({ payload }) {
  yield put(pendingUserModify());
  try {
    const request = yield call(getUserModify, payload);
    const { response, errors } = request;
    if (Number(response.status) === 0) {
      window.location.reload();
    }

    const data = !_.isNil(response) ? response : errors;
    if (!_.get(data, 'error', false)) del('sso');
    yield put(successUserModify(data));
  } catch (error) {
    yield put(errorUserModify(error));
  }
}

export default function* userModifySaga() {
  yield takeLatest(LOAD_USER_MODIFY.ACTION, sendUserModify);
}
